import React, { useRef, useEffect } from "react";
import classNames from "classnames";
 
export default function SiderModal({
  open,
  onClose,
  className,
  children,
  expanded,
  style,
}) {
  const modalRef = useRef(null);
  const backdropRef = useRef(null);
 
  useEffect(() => {
    if (open) {
      // Show the modal
      modalRef.current?.classList.add("translate-x-0");
      modalRef.current?.classList.remove("translate-x-full");
      backdropRef.current?.classList.add("opacity-100");
      backdropRef.current?.classList.remove("opacity-0");
    } else {
      // Hide the modal
      modalRef.current?.classList.remove("translate-x-0");
      modalRef.current?.classList.add("translate-x-full");
      backdropRef.current?.classList.remove("opacity-100");
      backdropRef.current?.classList.add("opacity-0");
    }
  }, [open]);
 
  return (
<div className={classNames("fixed inset-0 z-[1000]", { hidden: !open })}>
<div
        ref={backdropRef}
        className="fixed inset-0 bg-black bg-opacity-75 backdrop-filter backdrop-blur-sm opacity-0 transition-opacity duration-200"
        onClick={onClose}
      />
<div
        ref={modalRef}
        className={classNames(
          className,
          "fixed right-0 top-0 transform translate-x-full overflow-hidden rounded-lg h-full min-w-full sm:min-w-[499px] bg-white text-left shadow-xl transition-transform duration-500 sm:duration-700"
        )}
        style={{ width: expanded ? "calc(100vw - 80px)" : "20.33vw", ...style }}
>
<div className="relative z-10 h-full">{open && children}</div>
</div>
</div>
  );
}